import { v1ApiClient } from '@/services';
import type {
  PathParams,
  RequestBody,
  ResponseBody,
} from '@/shared/api/generated';

type EnableNotificationPath = '/v1/notifications/{notification_id}/enable';

type EnableNotificationParams = PathParams<EnableNotificationPath, 'patch'> &
  RequestBody<EnableNotificationPath, 'patch'>;
type EnableNotificationResponse = ResponseBody<EnableNotificationPath, 'patch'>;

/**
 * 알림 활성화/비활성화
 */
export const enableNotification = ({
  notification_id,
  enable,
}: EnableNotificationParams): Promise<EnableNotificationResponse> => {
  return v1ApiClient
    .patch(`/notifications/${notification_id}/enable`, { enable })
    .then((res) => res.data);
};
